import AllowToken from './AllowToken'
import AllowPair from './AllowPair'
import Transact from './Transact'

export default {
  AllowToken,
  AllowPair,
  Transact
}
